"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  SMALL: 'small',
  LARGE: 'large'
};
exports.default = _default;
//# sourceMappingURL=LikeSize.js.map